import { Component, Input } from '@angular/core';
import { NoteService } from '../../../core/services/note.service';

@Component({
    selector: 'app-note-link-line',
    templateUrl: './note-link-line.component.html',
    styleUrls: ['./note-link-line.component.scss'],
})
export class NoteLinkLineComponent {
    @Input() noteIds: number[] = [];
    @Input() ticket;

    constructor(private noteService: NoteService) {}

    viewLastNote() {
        this.noteService.noteIdWithMentionedUser = null;
        this.noteService.noteIdWithMentionedUser = this.noteIds[this.noteIds.length - 1];
        this.noteService.ignoreParamNoteId = true;
        this.noteService.disableNoteHighlighting = false;
        this.noteService.openNotes(this.ticket);
    }
}
